import { ChangeDetectionStrategy, Component, inject, input } from '@angular/core';
import {MatDialog} from "@angular/material/dialog";
import type NavigationMenu from "../../navigation.model";
import {Router} from "@angular/router";

@Component({
    selector: 'app-navigation-item',
    templateUrl: './item.component.html',
    styleUrls: ['./item.component.scss', '../menu-item.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class ItemComponent {
  private dialog = inject(MatDialog);
  private router = inject(Router);

  readonly item = input<NavigationMenu>(undefined);

  handle() {
    this.dialog.open(this.item().launch);
  }

  planUpload() {
    this.router.navigate(['/plans'], {queryParams: {upload: 'true'}})
  }

}
